import type {ReactElement} from 'react';
import {useRef} from 'react';
import classNames from 'classnames';
import type {SwitchProps} from '@interfaces/Switch';

export default function Switch(props: SwitchProps): ReactElement<SwitchProps> {
    const {className, label, labelPosition, disabled, ...rest} = {labelPosition: 'right', ...props};
    const inputRef = useRef<HTMLInputElement>(null);
    const classes = classNames({
        switch: true,
        disabled,
        [className!]: className,
    });

    return (
        <div className={classes}>
            {label && labelPosition === 'left' ? (
                <span className="switch__label--left">{label}</span>
            ) : null}
            <input
                type="checkbox"
                className="switch__input"
                disabled={disabled}
                ref={inputRef}
                {...rest}
            />
            {label && labelPosition === 'right' ? (
                <span className="switch__label--right">{label}</span>
            ) : null}
        </div>
    );
}
